import { NewCustomerListComponent } from './../new-customer-list/new-customer-list.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  

  constructor() { }

  ngOnInit() {
    
  }

}
